
const INIT_STATE = {
    list : [],
    rows : 0,
    targetRow : 0,
    detailList : [],
    detailRows : 0,
    detailTargetRow : 0,
    allList : [],
}

const managementCodeReducer = (state=INIT_STATE, action) => {
    switch(action.type){
        case 'INIT_STATE' : {
            return INIT_STATE;
        }
        case 'GET_COMMON_CODE_GROUP_KEYWORD_LIST_SUCCESS' : {
            return {
                ...state,
                ...action.payload,
            };
        }
        case 'GET_COMMON_CODE_DTL_LIST_GROUP_SUCCESS' : {
            return {
                ...state,
                ...action.payload,
            };
        }
        case 'GET_COMMON_CODE_DTL_LIST_GROUP_CLEAR' : {
            return {
                ...state,
                detailList : [],
                detailRows : 0,
                detailTargetRow : 0,
            };
        }
        case 'GET_COMMON_CODE_GROUP_SUCCESS' : {
            return {
                ...state,
                allList : action.payload.allList,
            };
        }
        case 'GET_COMMON_CODE_GROUP_LIST_SUCCESS' : {
            return {
                ...state,
                allList : action.payload.allList,
            };
        }
        
        default :
            return state;
    }
}

export default managementCodeReducer;